<template>
  <a-modal
    class="success-box"
    :visible="successVisible"
    :centered="true"
    :bodyStyle="{ padding: '0 30px' }"
    width="640px"
    @cancel="cancel"
  >
    <template #title>
      <div class="title-box">提示</div>
    </template>
    <p class="padding-tb-20 font-size-16">
      文档翻译已完成，请前往云译客【文档快翻】的【翻译记录】导出或查看。
    </p>
    <div class="img-box" style="height: 192px">
      <img src="@/images/experience-img.png" height="192" alt="" />
    </div>
    <template #footer>
      <div
        class="display-flex justify-end align-center padding-t-10 padding-b-10"
      >
        <div>
          <a-button size="large" @click="cancel" style="width: 120px">
            取消
          </a-button>
          <a-button
            key="submit"
            type="primary"
            size="large"
            @click="toPeFunc"
            style="width: 120px"
          >
            前往云译客
          </a-button>
        </div>
      </div>
    </template>
  </a-modal>
</template>

<script>
  export default {
    props: ['successVisible'],
    setup(props, ctx) {
      const cancel = () => {
        ctx.emit('update:successVisible', false)
      }
      const toPeFunc = () => {
        const _url = window.env.pe + '/pe?redirect=translation'
        window.location.href = window.env.login + '/cas/login?service=' + _url
      }
      return {
        cancel,
        toPeFunc,
      }
    },
  }
</script>

<style lang="scss">
  .success-box .ant-modal-close-x {
    width: 72px;
    height: 72px;
    line-height: 72px;
  }
  .success-box .ant-modal-header {
    padding: 25px 24px;
  }
  .success-box .ant-modal-footer {
    border: 0;
  }
</style>
